import { Briefcase, Sprout, Store, Building2, UserRound, TrendingUp } from "lucide-react";

const SEGMENTOS = [
    {
        icon: Briefcase,
        title: "Emprendedores",
        desc: "Apertura de empresas, primera contabilidad y acompañamiento desde la idea hasta la operación.",
    },
    {
        icon: Store,
        title: "PYMES y comercios",
        desc: "Contabilidad mensual, impuestos y asesoramiento para que el día a día no te frene del crecimiento.",
    },
    {
        icon: UserRound,
        title: "Servicios Profesionales",
        desc: "Asesoramiento ágil para profesionales independientes que quieren cumplir y crecer sin complicaciones.",
    },
    {
        icon: Sprout,
        title: "Empresas agropecuarias",
        desc: "Contabilidad rural, COMAP, IMEBA, créditos BROU y proyectos de inversión para el sector agro.",
    },
    {
        icon: Building2,
        title: "Empresas familiares",
        desc: "Acompañamos generaciones: sucesión, ordenamiento societario y planificación fiscal a largo plazo.",
    },
    {
        icon: TrendingUp,
        title: "Inversores con COMAP",
        desc: "Estructuramos y presentamos tu proyecto de inversión para acceder a beneficios fiscales.",
    },
];

export default function Benefits() {
    return (
        <section
            id="para-quien"
            data-testid="benefits-section"
            className="relative bg-[var(--uma-cream-soft)] py-24 md:py-32"
        >
            <div className="max-w-7xl mx-auto px-5 md:px-10">
                <div className="text-center max-w-3xl mx-auto reveal">
                    <div className="uma-eyebrow">Para quién trabajamos</div>
                    <h2 className="font-serif-display text-[36px] md:text-[56px] lg:text-[64px] leading-[1.02] mt-6 text-[var(--uma-forest)]">
                        Acompañamos a quien
                        <br />
                        <em className="italic font-light text-[var(--uma-gold)]">
                            quiere crecer ordenado.
                        </em>
                    </h2>
                    <p className="mt-6 text-[15px] md:text-[16px] leading-relaxed text-[var(--uma-text-soft)] font-light">
                        Desde el emprendedor que recién arranca hasta empresas
                        familiares con décadas de historia. Cada cliente recibe
                        el mismo nivel de atención, criterio y disponibilidad.
                    </p>
                </div>

                <div className="mt-16 md:mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
                    {SEGMENTOS.map((b, i) => {
                        const Icon = b.icon;
                        return (
                            <div
                                key={i}
                                data-testid={`benefit-card-${i}`}
                                className="reveal group bg-[var(--uma-cream-white)] border border-[var(--uma-forest)]/8 rounded-2xl p-7 md:p-8 transition-all hover:bg-[var(--uma-forest)] hover:text-[var(--uma-cream)] hover:-translate-y-1 hover:shadow-[0_14px_40px_-12px_rgba(10,38,20,0.18)]"
                            >
                                <div className="w-12 h-12 rounded-xl bg-[var(--uma-cream-soft)] text-[var(--uma-forest)] flex items-center justify-center group-hover:bg-[var(--uma-gold)] group-hover:text-[var(--uma-forest)] transition-colors">
                                    <Icon className="h-5 w-5" strokeWidth={1.5} />
                                </div>
                                <h3 className="font-serif-display text-[24px] md:text-[26px] text-[var(--uma-forest)] group-hover:text-[var(--uma-cream)] leading-tight mt-5 transition-colors">
                                    {b.title}
                                </h3>
                                <p className="mt-3 text-[14px] leading-relaxed text-[var(--uma-text-soft)] group-hover:text-[var(--uma-cream)]/75 font-light transition-colors">
                                    {b.desc}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
